import styled from 'styled-components';
import React, { FC } from 'react';
import { FilterIcon, FiltersPopover, palette } from '@dev/ee-components';
import { Grid } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import dayjs from '@api/services/tools/dayjs';

import { SearchFilter } from './logFilters/SearchFilter';
import { DATE_FORMAT } from '../LogsFiltersBarInterfaces';
import { splitSelectedItemsIntoProperState } from '../../../helperFunctions';
import { useEventsFilters } from '../../../hooks/useEventFilter';
import { useMobileFilterTabs } from '../../../hooks/useMobileFiltersTab';

const MobileSearch = styled(Grid)`
    margin-top: 32px;
`;

const IconWrapper = styled.div`
    background: ${palette.basic.paper};
    border: 1px solid ${palette.indigo[6]};
    border-radius: 4px;
    height: 44px;
    width: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

enum SelectedFilterEnum {
    ALL = 'all',
}

interface MobileLogsFilterBarInterface {
    onChangeFilters(selectedFilters: Record<string, any>): void;
    availableFilters?: Record<string, boolean>;
}

export const MobileLogsFilterBar: FC<MobileLogsFilterBarInterface> = ({
    onChangeFilters,
    availableFilters,
}: MobileLogsFilterBarInterface): JSX.Element => {
    const { t } = useTranslation();
    const tabs = useMobileFilterTabs(availableFilters);
    const { fetchEventsCounts } = useEventsFilters({});

    const parseMobileFilters = ({ date, channel, campaign, event }: Record<string, any>, calendarFrom: string, calendarTo: string) => {
        let to;
        let from;

        if (!calendarFrom) {
            to = dayjs();
            from = dayjs().subtract(+date, 'day').startOf('day');
        }
        if (calendarFrom) {
            from = dayjs(calendarFrom).startOf('day');
            to = dayjs(calendarTo);
        }

        const [statuses, result] = splitSelectedItemsIntoProperState(event);

        const updatedFilters = {
            from: from.format(DATE_FORMAT),
            to: to.format(DATE_FORMAT),
            channel: channel === SelectedFilterEnum.ALL ? null : channel,
            campaign: campaign === SelectedFilterEnum.ALL ? null : campaign,
            statuses,
            result,
        };
        onChangeFilters(updatedFilters);
    };

    return (
        <MobileSearch container justifyContent="space-between" wrap="nowrap">
            <Grid item xs={11} style={{ marginLeft: 12 }}>
                <SearchFilter />
            </Grid>
            <Grid item style={{ marginLeft: 16 }}>
                <IconWrapper>
                    <FiltersPopover
                        title={t('filters')}
                        onApply={parseMobileFilters}
                        translations={{ apply: t('apply'), to: t('to'), close: t('close') }}
                        tabs={tabs}
                    >
                        <FilterIcon color="#718096" height={20} width={20} onClick={fetchEventsCounts} />
                    </FiltersPopover>
                </IconWrapper>
            </Grid>
        </MobileSearch>
    );
};
